"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends6 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactBootstrap = require("react-bootstrap");

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _proLightSvgIcons = require("@fortawesome/pro-light-svg-icons");

var _config = require("../../../config/config");

function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
      t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}

function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };

  var t = _getRequireWildcardCache(r);

  if (t && t.has(e)) return t.get(e);
  var n = {
    __proto__: null
  },
      a = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var u in e) {
    if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }

  return n["default"] = e, t && t.set(e, n), n;
}

var DropdownOption = function DropdownOption(_ref) {
  var answer = _ref.answer,
      handleEditAnswer = _ref.handleEditAnswer,
      handleAnswerBlur = _ref.handleAnswerBlur,
      enableRemove = _ref.enableRemove,
      handleRemoveAnswer = _ref.handleRemoveAnswer,
      errorMessages = _ref.errorMessages;

  var _useState = (0, _react.useState)({
    answer_option: false,
    size: false,
    character_spacing: false
  }),
      focusActive = _useState[0],
      setFocusActive = _useState[1];

  var handleFocus = function handleFocus(e) {
    var _extends2, _extends3;
    /* eslint-disable-next-line */


    e.target.value ? setFocusActive((0, _extends6["default"])({}, focusActive, (_extends2 = {}, _extends2[e.target.name] = true, _extends2))) : setFocusActive((0, _extends6["default"])({}, focusActive, (_extends3 = {}, _extends3[e.target.name] = false, _extends3)));
  };

  var onRemoveAnswer = function onRemoveAnswer(name, id) {
    var _extends4;

    setFocusActive((0, _extends6["default"])({}, focusActive, (_extends4 = {}, _extends4[name] = false, _extends4)));
    handleRemoveAnswer(id);
  };

  var onEditAnswer = function onEditAnswer(e) {
    handleFocus(e);
    handleEditAnswer(e);
  };

  var onBlurAnswer = function onBlurAnswer(e) {
    var _extends5;

    setFocusActive((0, _extends6["default"])({}, focusActive, (_extends5 = {}, _extends5[e.target.name] = false, _extends5)));
    handleAnswerBlur(e);
  };

  var validateEmptyAnswer = function validateEmptyAnswer(name) {
    return name === '__answer_name__' ? '' : name;
  };

  var optionsValidation = function optionsValidation() {
    if (errorMessages && validateEmptyAnswer(answer.name) === '') {
      return true;
    }

    if (validateEmptyAnswer(answer.name) !== '') {
      return false;
    }

    return true;
  };

  return (
    /*#__PURE__*/
    _react["default"].createElement(_react.Fragment, {
      key: answer.id
    },
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.InputGroup, {
      className: "mb-2"
    },
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.FormControl, {
      className: "form-input",
      name: "answer_option",
      "aria-describedby": "basic-addon3",
      answerid: answer.id,
      required: true,
      isInvalid: optionsValidation(),
      value: answer.name ? validateEmptyAnswer(answer.name) : '',
      onChange: onEditAnswer,
      "data-cy": "option-input-" + answer.id,
      placeholder: "Type Answer Option",
      onClick: function onClick() {},
      onFocus: function onFocus() {},
      onBlur: onBlurAnswer
    }), enableRemove &&
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.InputGroup.Append, null,
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Button, {
      answerid: answer.id,
      onClick: function onClick() {
        return onRemoveAnswer(answer.name, answer.id);
      },
      variant: "light",
      className: "remove-option-button",
      style: {
        backgroundColor: 'white',
        border: '1px solid lightgray',
        borderLeft: 'none'
      }
    },
    /*#__PURE__*/
    _react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
      id: answer.id,
      icon: _proLightSvgIcons.faTimesCircle,
      className: "text-dark",
      onClick: function onClick() {
        return onRemoveAnswer(answer.name, answer.id);
      },
      "data-cy": "option-delete-" + answer.id,
      "data-testid": "option-delete-" + answer.id
    }))),
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Form.Control.Feedback, {
      type: "invalid"
    }, _config.FIELD_NAME_FEEDBACK)))
  );
};

DropdownOption.defaultProps = {
  answer: {},
  enableRemove: false,
  errorMessages: false
};
DropdownOption.propTypes = process.env.NODE_ENV !== "production" ? {
  // eslint-disable-next-line react/forbid-prop-types
  answer: _propTypes["default"].object,
  handleEditAnswer: _propTypes["default"].func.isRequired,
  handleRemoveAnswer: _propTypes["default"].func.isRequired,
  handleAnswerBlur: _propTypes["default"].func.isRequired,
  errorMessages: _propTypes["default"].bool,
  enableRemove: _propTypes["default"].bool
} : {};

var _default = exports["default"] = DropdownOption;